<!--
  @component
  Generates HTML text labels for a nested data structure. It places the label near the y-value of the highest x-valued data point. This is useful for labeling the final point in a multi-series line chart, for example. It expects your data to be an array of objects where each has `values` field that is an array of data objects. It uses the `z` field accessor to pull the text label.
 -->
<script>
	import { getContext } from "svelte";
	import { fade } from "svelte/transition";
	import { quintOut } from "svelte/easing";

	export let series;
	export let lineDrawDuration;

	/* --------------------------------------------
	 * Put the label on the highest value
	 */
</script>

{#each series as { label, topic, id, color, labelPosition } (id || topic)}
	{#if label}
		<div
			in:fade={{ duration: 300, delay: lineDrawDuration, ease: quintOut }}
			class="label"
			style="
    top:{labelPosition.top}%;
    left:{labelPosition.left || 50}%;
  "
		>
			<span style="color:{color}">{label}</span>
		</div>
	{/if}
{/each}

<style lang="scss">
	.label {
		position: absolute;
		transform: translateX(-30%);

		span {
			white-space: nowrap;
			display: block;
			text-align: center;
			font-family: Franklin Gothic FS;
			font-size: 15px;
			font-style: normal;
			font-weight: $medium;
			line-height: 120%; /* 18px */
			letter-spacing: 1.35px;
			text-transform: uppercase;
			text-shadow: -2px -2px 0 #211c46, 2px -2px 0 #211c46, -2px 2px 0 #211c46, 2px 2px 0 #211c46;

			// @media (max-width: $breakpoint-mobile) {
			// 	white-space: normal;
			// }
		}
	}
</style>
